// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".536.0.0." + {"1367": "21d3a7f0f8a6569f","2257": "ab353bd6a3b9953e","2973": "14151b45fe927e54","582": "1ae1e523e18f5dff","7530": "5f3983d9009179f5","7581": "484b6e9da258f5b5","8692": "df067af3320db117",}[chunkId] + ".css"
}